module.exports = __webpack_public_path__ + "img/wales.b20a0a0e.svg";